<template>
    <el-skeleton :rows="12" :loading="loading" animated>
        <template #default>
            <el-form ref="formRef" :disabled="saving" :rules="rules" :model="video" label-position="top">
                <el-form-item prop="title" label="Título do vídeo">
                    <el-input name="title" type="text" v-model="video.title" />
                </el-form-item>

                <video v-if="video.path" controls :style="{width: '100%'}">
                    <source :src="`${Api.publicUrl}alt-storage?path=videos/${video.path}`">
                </video>

                <el-form-item label="Descrição" prop="description">
                    <el-input type="textarea" name="description" v-model="video.description" minlength="1" />
                </el-form-item>
        
                <el-button plain :loading="saving" size="large" type="primary" @click.prevent="submit(formRef)">
                    Atualizar
                </el-button>
            </el-form>

        </template>
    </el-skeleton>
</template>

<script lang="ts" setup>
    import Api from "@/services/api"
    import { Video } from "@/services/types"
    import { ElMessage, FormInstance, FormRules } from "element-plus"
    import { reactive, ref } from "vue"

    // eslint-disable-next-line no-undef
    const props = defineProps<{
        video: Video
    }>()

    // eslint-disable-next-line no-undef
    const emit = defineEmits<{
        update: []
    }>()

    const video = reactive<Video>({
        title: props.video.title,
        description: props.video.description,
        path: props.video.path,
        id: props.video.id
    })

    const rules = reactive<FormRules<Video>>({
        title: [{required: true, message: 'Insira o título do vídeo', min: 1}],
        description: [{required: true, message: 'Informe a descrição'}],
    })

    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const loading = ref<boolean>(false)

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true
                const data = new FormData()
                data.append('title', video.title)
                data.append('description', video.description)
                
                const res = await Api.put('admin/videos/' + video.id, video, data)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Video cadastrado com sucesso'})
                    emit("update")
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }
</script>
